export const UtcDateToCurrentTimeZone = (date) => {
  var utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(utcDate);
};

export const UtcDateStringToCurrentTimeZone = (date) => {
  return UtcDateToCurrentTimeZone(new Date(date));
};
